'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DomainBuilder = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _hateoasModelFactory = require('./hateoasModelFactory');

var _hateoasModelFactory2 = _interopRequireDefault(_hateoasModelFactory);

var _rpcModelFactory = require('./rpc/rpcModelFactory');

var _simpleModelFactory = require('./simpleModelFactory');

var _simpleModelFactory2 = _interopRequireDefault(_simpleModelFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DomainBuilder = exports.DomainBuilder = function () {
    function DomainBuilder(domain) {
        _classCallCheck(this, DomainBuilder);

        this.domain = domain;
        this.definitionCallbacks = [];
    }

    _createClass(DomainBuilder, [{
        key: 'registerDefinitionCallback',
        value: function registerDefinitionCallback(Model, definitionCallback) {
            var _this = this;

            this.definitionCallbacks.push(function () {
                definitionCallback(Model, _this.domain);
            });
        }
    }, {
        key: 'runDefineCallbacks',
        value: function runDefineCallbacks() {
            _underscore2.default.forEach(this.definitionCallbacks, function (definitionCallback) {
                return definitionCallback();
            });
        }

        /**
         * create new hateoas model (linked to rest-backend)
         * @param className {string}
         * @param hateoasType {string}
         * @param definitionCallback {function}
         */

    }, {
        key: 'defineModel',
        value: function defineModel(className, hateoasType, definitionCallback) {
            var _this2 = this;

            _auroraJavascriptUtils.assert.string(className);
            _auroraJavascriptUtils.assert.string(hateoasType);
            _auroraJavascriptUtils.assert.func(definitionCallback);

            if (this.domain.models[className]) {
                throw new Error('Model with class \'' + className + '\' already defined in module \'' + this.domain.domainName);
            }

            var Model = (0, _hateoasModelFactory2.default)(className, hateoasType, this.domain);
            this.domain.models[className] = Model;

            this.domain._cache.createCacheForModel(Model);

            // enrich model
            Model.fetchModel = function (modelId, forceRetrieve) {
                var model = _this2.domain._cache.getEntity(hateoasType, modelId);
                if (forceRetrieve) {
                    return model.fetch();
                }

                return model;
            };

            Model.newModel = function (props) {
                var model = new Model(props);
                _this2.domain._cache.addEntity(model);
                return model;
            };

            this.registerDefinitionCallback(Model, definitionCallback);

            return Model;
        }

        /**
         * Create new read-only hateoas model (linked to rest-backend)
         * Read-only - means that we can fetch this model by id.
         * Main purpose - search. Example - Reports in affiliate system
         * @param className {string}
         * @param definitionCallback {function}
         */

    }, {
        key: 'defineReadOnlyModel',
        value: function defineReadOnlyModel(className, definitionCallback) {
            _auroraJavascriptUtils.assert.string(className);
            _auroraJavascriptUtils.assert.func(definitionCallback);

            if (this.domain.models[className]) {
                throw new Error('Model with class \'' + className + '\' already defined in module \'' + this.domain.domainName);
            }

            var Model = (0, _hateoasModelFactory.createReadOnlyModel)(className, this.domain);
            this.domain.models[className] = Model;

            this.domain._cache.createCacheForModel(Model);

            this.registerDefinitionCallback(Model, definitionCallback);

            return Model;
        }

        /**
         * create new simple model (embedded for hateoasModel, for example)
         * @param className {string}
         * @param definitionCallback {function}
         */

    }, {
        key: 'defineSimpleModel',
        value: function defineSimpleModel(className, definitionCallback) {
            _auroraJavascriptUtils.assert.string(className);
            _auroraJavascriptUtils.assert.func(definitionCallback);

            if (this.domain.models[className]) {
                throw new Error('Model with class \'' + className + '\' already defined in module \'' + this.domain.domainName);
            }

            var Model = (0, _simpleModelFactory2.default)(className, this.domain);
            this.domain.models[className] = Model;

            this.registerDefinitionCallback(Model, definitionCallback);

            return Model;
        }

        /**
         * create request/response model definition
         * @param className {string}
         * @param definitionCallback {function}
         */

    }, {
        key: 'defineRpcModel',
        value: function defineRpcModel(className, definitionCallback) {
            _auroraJavascriptUtils.assert.string(className);
            _auroraJavascriptUtils.assert.func(definitionCallback);

            if (this.domain.models[className]) {
                throw new Error('Model with class \'' + className + '\' already defined in module \'' + this.domain.domainName);
            }

            var Model = (0, _rpcModelFactory.createRpcModel)(className, this.domain);

            this.domain.models[className] = Model;

            this.registerDefinitionCallback(Model, definitionCallback);

            return Model;
        }
    }]);

    return DomainBuilder;
}();


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/DomainBuilder.js
// module id = 1409
// module chunks = 118